import axios from "axios";
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_DATASET_URL = process.env.VUE_APP_API_URL+"/datasets";

export default class DatasetController {
    // Generate dataset for one student
    static async generateDatasetForStudent(student_id) {
        this._validateId(student_id);
        const response = await axios.post(`${API_DATASET_URL}/generate_dataset_by_student_id/${student_id}`);
        console.log("Dataset generate - send successfully:", response.data);
        return response.data;
    }

    static async generateDatasetsForStudentsUcos(list_of_students_ucos) {
        console.log("List of ucos:", list_of_students_ucos);
        const response = await axios.post(`${API_DATASET_URL}/generate_datasets_by_students_ucos`, list_of_students_ucos);
        console.log("Datasets generate - send successfully:", response.data);
        return response.data;
    }

    static async getDatasetForStudent(student_id) {
        this._validateId(student_id);
        const response = await axios.get(`${API_DATASET_URL}/get_dataset_by_student_id/${student_id}`);
        console.log("Dataset get - send successfully:", response.data);
        return response.data;
    }

    static async generateDatasetsForAllStudents(regenerateAll = false) {
        const response = await axios.post(`${API_DATASET_URL}/generate_datasets_for_all_students`, null, {
            params: { regenerate_all: regenerateAll }
        });
        console.log("Datasets generate - send successfully:", response.data);
        return response.data;
    }

    static async checkAllStudentsHaveDatasets() {
        const response = await axios.get(`${API_DATASET_URL}/check_all_students_have_datasets`);
        console.log("Check all students have datasets - send successfully:", response.data);
        return response.data;
    }

    static async deleteDataset(dataset_id) {
        this._validateId(dataset_id);
        const response = await axios.delete(`${API_DATASET_URL}/delete_dataset/${dataset_id}`);
        console.log("Dataset delete - send successfully:", response.data);
        return response.data;
    }

    static _validateId(student_id) {
        if (!Number.isInteger(student_id)) {
            throw new Error('ID must be an integer');
        }
    }
}

applyErrorHandlers(DatasetController);
